export default "__VITE_ASSET__f1a41fe0__"